import { Link } from '@carbon/react';
import { useTranslation } from '@pos/i18n';
import { useBranding } from './branding';
import './PoweredBy.scss';

/** The "Powered by <platform>" note for the footer of every app. Text comes from branding.json; nothing without it. */
export function PoweredBy({ className }: { className?: string }) {
  const { t } = useTranslation();
  const poweredBy = useBranding()?.poweredBy;
  const name = poweredBy?.name?.trim();
  if (!name) return null;

  const text = t('common.poweredBy', { name });
  const url = poweredBy?.url?.trim();
  const classes = className ? `pos-powered-by ${className}` : 'pos-powered-by';
  return (
    <span className={classes}>
      {url && /^https?:\/\//i.test(url) ? (
        <Link href={url} target="_blank" rel="noopener noreferrer" size="sm">
          {text}
        </Link>
      ) : (
        text
      )}
    </span>
  );
}
